import { Icon } from '@components/index';
import { ACCOUNT_TYPE_INFO_TOOLTIP_CONTENT } from '@constants/generic';
import AccountTypeInfo from '@features/authentication/pages/account-selection/AccountTypeInfo';

import theme from '../../../../themes/colors';

interface BusinessTypeSelectorProps {
  selectedBusinessType: 'organisation' | 'individual';
  setSelectedBusinessType: (
    businessType: 'organisation' | 'individual'
  ) => void;
}

const BusinessTypeSelector = ({
  selectedBusinessType,
  setSelectedBusinessType
}: BusinessTypeSelectorProps) => {
  const isIndividual = selectedBusinessType === 'individual';

  return (
    <div>
      <div className="flex items-center gap-2">
        <span className="text-base font-semibold text-cofeeNeutral10">
          Business Type
        </span>
        <AccountTypeInfo tooltipContent={ACCOUNT_TYPE_INFO_TOOLTIP_CONTENT} />
      </div>
      <div className="mb-6 mt-3 flex w-full items-center gap-4">
        {/* Individual */}
        <div
          className={`flex w-full cursor-pointer items-center gap-2 rounded-xl px-4 py-3 ${
            isIndividual
              ? 'border border-cofeePrimary6 text-cofeePrimary6'
              : 'border border-cofeeGreyBlue5 text-cofeeNeutral10'
          }`}
          onClick={() => setSelectedBusinessType('individual')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setSelectedBusinessType('individual');
            }
          }}
        >
          <div
            className={`flex size-6 items-center justify-center rounded-full ${
              isIndividual
                ? 'border-none bg-cofeePrimary6'
                : 'border border-cofeeNeutral8 bg-cofeeNeutral1'
            }`}
          >
            <Icon
              name="user"
              stroke={isIndividual ? theme.cofeeNeutral1 : theme.cofeeNeutral8}
              size="16"
            />
          </div>
          <span className="text-sm font-medium">Individual</span>
        </div>
        {/* Organization */}
        <div
          className={`flex w-full cursor-pointer items-center gap-2 rounded-xl px-4 py-3 ${
            !isIndividual
              ? 'border border-cofeePrimary6 text-cofeePrimary6'
              : 'border border-cofeeGreyBlue5 text-cofeeNeutral10'
          }`}
          onClick={() => setSelectedBusinessType('organisation')}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              setSelectedBusinessType('organisation');
            }
          }}
        >
          <div
            className={`flex size-6 items-center justify-center rounded-full ${
              !isIndividual
                ? 'border-none bg-cofeePrimary6'
                : 'border border-cofeeNeutral8 bg-cofeeNeutral1'
            }`}
          >
            <Icon
              name="users"
              stroke={!isIndividual ? theme.cofeeNeutral1 : theme.cofeeNeutral8}
              size="16"
            />
          </div>
          <span className="text-sm font-medium">Organization</span>
        </div>
      </div>
    </div>
  );
};

export default BusinessTypeSelector;
